var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "gnb" }, [
    _vm.enableUserMenu && _vm.isEmpty(_vm.session.uuid)
      ? _c("div", { staticClass: "top_wrap" }, [
          _c(
            "a",
            {
              staticClass: "btn_login",
              attrs: { href: _vm.getToastIdUrl("login") }
            },
            [_vm._v(_vm._s(_vm.$t("gnb.signin")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              class: _vm.showGnb ? "btn_gnb_close" : "showGnb",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.setShowGnb(!_vm.showGnb)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("gnb.toggle-show-gnb")))]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.enableUserMenu && _vm.exist(_vm.session.uuid)
      ? _c("div", { staticClass: "top_wrap" }, [
          _c("span", { staticClass: "member_id" }, [
            _vm._v(_vm._s(_vm.session.maskedEmail))
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn_logout",
              attrs: { href: _vm.getToastIdUrl("logout") }
            },
            [_vm._v(_vm._s(_vm.$t("gnb.signout")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              class: _vm.showGnb ? "btn_gnb_close" : "showGnb",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.setShowGnb(!_vm.showGnb)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("gnb.toggle-show-gnb")))]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "gnb_scroll_wrap" }, [
      _c(
        "ul",
        { staticClass: "lst_gnb" },
        _vm._l(_vm.gnbMenusOnlyShow, function(gnbMenu, gnbMenuNo) {
          return _c(
            "li",
            {
              key: gnbMenu.content,
              staticClass: "gnb_menu is_m_show",
              class: {
                is_point: gnbMenu.type == "button",
                has_left_gap: _vm.exist(gnbMenu.rightSideMenuComopnent)
              },
              on: {
                mouseover: function($event) {
                  _vm.hoverCustomMenu(gnbMenu, true)
                },
                mouseout: function($event) {
                  _vm.hoverCustomMenu(gnbMenu, false)
                }
              }
            },
            [
              !_vm.exist(gnbMenu.subMenus) &&
              !_vm.exist(gnbMenu.subMenuComponent)
                ? [
                    _c(
                      "router-link-ex",
                      {
                        staticClass: "link_menu",
                        class: {
                          is_hover: gnbMenu.hover,
                          is_m_show: !_vm.exist(gnbMenu.rightSideMenuComopnent)
                        },
                        attrs: {
                          condition: !gnbMenu.isExternal,
                          to: _vm.getGnbMenuUrl(gnbMenu),
                          "active-class": "is_selected",
                          target: gnbMenu.isBlank ? "_blank" : "_self"
                        }
                      },
                      [
                        _c("span", { staticClass: "menu_txt" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.isEmpty(gnbMenu.messageId)
                                  ? gnbMenu.content
                                  : _vm.$t(gnbMenu.messageId)
                              ) +
                              "\n              "
                          ),
                          gnbMenu.showIcoLink
                            ? _c("span", { staticClass: "ico_link" }, [
                                _vm._v("바로 가기")
                              ])
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.exist(gnbMenu.rightSideMenuComopnent)
                      ? _c(gnbMenu.rightSideMenuComopnent, { tag: "component" })
                      : _vm._e()
                  ]
                : _c(
                    "a",
                    {
                      staticClass: "link_menu is_m_show",
                      class: { collapsed: !gnbMenu.showCollapse },
                      attrs: {
                        "aria-controls": "gnb_menu_collapse_" + gnbMenuNo,
                        "aria-expanded": gnbMenu.showCollapse
                          ? "true"
                          : "false",
                        "data-toggle": "collapse"
                      },
                      on: {
                        click: function($event) {
                          gnbMenu.showCollapse = !gnbMenu.showCollapse
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "menu_txt" }, [
                        _vm._v(
                          _vm._s(
                            _vm.isEmpty(gnbMenu.messageId)
                              ? gnbMenu.content
                              : _vm.$t(gnbMenu.messageId)
                          )
                        )
                      ])
                    ]
                  ),
              _vm._v(" "),
              _vm.exist(gnbMenu.subMenus) || _vm.exist(gnbMenu.subMenuComponent)
                ? _c(
                    "b-collapse",
                    {
                      staticClass: "drop_menu_wrap",
                      attrs: { id: "gnb_menu_collapse_" + gnbMenuNo },
                      on: {
                        mouseover: function($event) {
                          _vm.hoverCustomMenu(gnbMenu, true)
                        },
                        mouseout: function($event) {
                          _vm.hoverCustomMenu(gnbMenu, false)
                        }
                      },
                      model: {
                        value: gnbMenu.showCollapse,
                        callback: function($$v) {
                          _vm.$set(gnbMenu, "showCollapse", $$v)
                        },
                        expression: "gnbMenu.showCollapse"
                      }
                    },
                    [
                      _vm.exist(gnbMenu.subMenus)
                        ? _c(
                            "ul",
                            { staticClass: "lst_gnb_sub" },
                            _vm._l(
                              _vm.subMenusNotPc(gnbMenu.subMenus),
                              function(subMenu) {
                                return _vm.isGnbSubMenuPartShow(subMenu)
                                  ? _c(
                                      "li",
                                      {
                                        key: subMenu.content,
                                        staticClass: "gnb_sub_menu"
                                      },
                                      [
                                        _c(
                                          "router-link-ex",
                                          {
                                            staticClass: "menu_txt",
                                            attrs: {
                                              to: _vm.addCountryIfHomepageUrl(
                                                subMenu.url
                                              ),
                                              condition: !subMenu.isExternal,
                                              target: subMenu.isBlank
                                                ? "_blank"
                                                : "_self"
                                            },
                                            nativeOn: {
                                              click: function($event) {
                                                _vm.hoverCustomMenu(
                                                  gnbMenu,
                                                  false
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.isEmpty(subMenu.messageId)
                                                    ? subMenu.content
                                                    : _vm.$t(subMenu.messageId)
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              }
                            )
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.exist(gnbMenu.subMenuComponent)
                        ? _c(gnbMenu.subMenuComponent, {
                            tag: "component",
                            on: {
                              close: function($event) {
                                _vm.hoverCustomMenu(gnbMenu, false)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }